import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"
import ImportFichados from "./Imports/ImportFichados"
import acusacionOptions from "../../common/acusacionOptions"

const AdminFichadosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  const [showImportExcel, setShowImportExcel] = React.useState(false)
  const toggleImportExcel = () => {
    setShowImportExcel(!showImportExcel)

  }
  return (<>
    {showImportExcel && <ImportFichados toggle={toggleImportExcel} />}
    <CRUD
      id="fichados"
      // additionalButtons={[
      //   <button key="customButton"
      //     className="btn btn-sm btn-secondary me-2"
      //     onClick={() => toggleImportExcel()}>
      //     {t("Importar Fichados XLSX")}
      //   </button>
      // ]}
      isModal={false}
      cssClass="modalRight"
      recordButtonsPosition="start"
      filterOpen={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      title={t("Fichas") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`fichados/fichados`}
      addEditRecordPath={`fichados/addEdit?currentUserId=${user.ID}`}
      deleteRecordPath="fichados/delete"
      filterFields={[
        {
          name: "id",
          htmlType: "text",
          dbType: "string",
          title: t("Cédula") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "nombre",
          htmlType: "text",
          dbType: "string",
          title: t("Nombre") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "apellido1",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 1") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },

        {
          name: "apellido2",
          htmlType: "text",
          dbType: "string",
          title: t("Apellido 2") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "alias",
          htmlType: "text",
          dbType: "string",
          title: t("Alias") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
        {
          name: "noFicha",
          htmlType: "text",
          dbType: "string",
          title: t("No. Ficha") ?? "",
          containerClass: "col-md-4 col-12",
          required: false,
        },
      ]}
      fieldsList={[
        {
          name: "cedula",
          title: t("Informe "),
          htmlType: "informe"
        },

        {
          name: "cedula",
          title: t("Cédula"),
        },
        {
          name: "nombre",
          title: t("Nombre"),
        },
        {
          name: "apellido1",
          title: t("Apellido 1"),
        },
        {
          name: "apellido2",
          title: t("Apellido 2"),
        },
        {
          name: "alias",
          title: t("Alias"),
        },
        {
          name: "fechaFichado",
          title: t("Fecha Fichado"),
          htmlType: "date",
        },
        {
          name: "noFicha",
          title: t("Ficha"),

        },
        {
          name: "ofensa",
          title: t("Ofensa"),

        },
        {
          name: "tipoFicha",
          title: t("Tipo de Ficha"),
        },
        // {
        //   name: "motivoFicha",
        //   title: t("Detalle"),
        //   cssClass: "text-wrap"
        // },
        {
          name: "agraviadoCedula",
          title: t("Cédula Agraviado"),
          htmlType: "informe"
        },
        {
          name: "agraviado",
          title: t("Victima"),

        },
        {
          name: "compliceIdentificador1",
          title: t("Complice 1 ID"),
          htmlType: "linkComplice"
        },
        {
          name: "compliceNombre1",
          title: t("Complice 1 Nombre"),
        },
        {
          name: "compliceIdentificador2",
          title: t("Complice 2 ID"),
          htmlType: "linkComplice"
        },
        {
          name: "compliceNombre2",
          title: t("Complice 2 Nombre"),
        },
        {
          name: "compliceIdentificador3",
          title: t("Complice 3 ID"),
          htmlType: "linkComplice"
        },
        {
          name: "compliceNombre3",
          title: t("Complice 3 Nombre"),
        },
        {
          name: "compliceIdentificador4",
          title: t("Complice 4 ID"),
          htmlType: "linkComplice"
        },
        {
          name: "compliceNombre4",
          title: t("Complice 4 Nombre"),
        },
        {
          name: "compliceIdentificador5",
          title: t("Complice 5 ID"),
          htmlType: "linkComplice"
        },
        {
          name: "compliceNombre5",
          title: t("Complice 5 Nombre"),
        },
        {
          name: "enlace",
          title: t("Enlace 1"),
          htmlType: "link"
        },
        {
          name: "enlace2",
          title: t("Enlace 2"),
          htmlType: "link"
        },
        {
          name: "enlace3",
          title: t("Enlace 3"),
          htmlType: "link"
        },
        {
          name: "enlace4",
          title: t("Enlace 4"),
          htmlType: "link"
        },


        {
          name: "enlace5",
          title: t("Enlace 5"),
          htmlType: "link"
        }
      ]}
      fields={[
        { name: "separator", dbType: "string", title: t("Datos Personales") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "cedula", required: true, htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombre", htmlType: "text", dbType: "string", title: t("Nombre") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "apellido1", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "apellido2", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias", htmlType: "text", dbType: "string", title: t("Alias") ?? "", containerClass: "col-12 col-md-6" },

        { name: "fotoCedula", htmlType: "picture", dbType: "string", title: t("Foto Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "separator", dbType: "string", title: t("Datos Caso") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "fotoCaso", htmlType: "picture", dbType: "string", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fechaFichado", htmlType: "date", dbType: "string", title: t("Fecha Fichado") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noFicha", htmlType: "text", dbType: "string", title: t("No. Orden Judicial") ?? "", containerClass: "col-12 col-md-6", required: false },
        {
          name: "tipoFicha", htmlType: "select", dbType: "string", title: t("Tipo de Ficha") ?? "", containerClass: "col-12 col-md-6", required: true,
          dataSourceLocal: [{ id: "Normal", name: "Normal" }, { id: "Blanca", name: "Blanca" }],
          dataSourceTextField: "name",
          dataSourceValueField: "id",
        },
        {
          name: "ofensa", htmlType: "selectMultiple", dbType: "array", title: t("Acusación") ?? "", containerClass: "col-12 col-md-6", required: true,
          dataSourceLocal: acusacionOptions,
          dataSourceTextField: "name",
          dataSourceValueField: "id",
        },
        { name: "agraviadoCedula", htmlType: "cedula", dbType: "string", title: t("Cédula Victima") ?? "", containerClass: "col-12 col-md-6" },
        { name: "agraviado", htmlType: "text", dbType: "string", title: t("Victima") ?? "", containerClass: "col-12 col-md-6" },
        { name: "motivoFicha", htmlType: "textarea", dbType: "string", title: t("Detalles") ?? "", containerClass: "col-12 " },
        { name: "separator", dbType: "string", title: t("Fuentes") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "enlace", htmlType: "text", dbType: "string", title: t("Enlace 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace2", htmlType: "text", dbType: "string", title: t("Enlace 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace3", htmlType: "text", dbType: "string", title: t("Enlace 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace4", htmlType: "text", dbType: "string", title: t("Enlace 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "enlace5", htmlType: "text", dbType: "string", title: t("Enlace 5") ?? "", containerClass: "col-12 col-md-6" },

        { name: "separator", dbType: "string", title: t("Búsqueda") ?? "", htmlType: "separator", containerClass: "col-12" },
        { name: "socialSearch", htmlType: "socialSearch", dbType: "string", title: t("Buscar en") ?? "", containerClass: "col-12" },


      ]}
    />
  </>
  )
}

export default AdminFichadosComponent
